import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

const fontFamilies = [
  // {
  //   label: "Roboto",
  //   value: '"Roboto", sans-serif'
  // },
  {
    label: "Arial",
    value: "Arial, Helvetica, sans-serif"
  },
  {
    label: "Calibri",
    value: '"Calibri", "Segoe UI", Arial, sans-serif'
  },
  {
    label: "Times New Roman",
    value: '"Times New Roman", Times, serif'
  }
];

export default function FontFamilySelector() {
  const defaultFontFamily = '"Calibri", "Segoe UI", Arial, sans-serif';

  const [selectedFontFamily, setSelectedFontFamily] = useState(
    localStorage.getItem("appFontFamily") ?? defaultFontFamily
  );

  const changeFontFamily = (e: any) => {
    const fontFamily = e.value;

    setSelectedFontFamily(fontFamily);

    document.documentElement.style.setProperty(
      "--font-primary",
      fontFamily
    );

    document.documentElement.style.setProperty(
      "--font-family",
      fontFamily
    );

    localStorage.setItem("appFontFamily", fontFamily);

    window.dispatchEvent(new Event("fontFamilyChanged"));
  };

  useEffect(() => {
    const savedFontFamily =
      localStorage.getItem("appFontFamily") ??
      '"Calibri", "Segoe UI", Arial, sans-serif';

    document.documentElement.style.setProperty(
      "--font-primary",
      savedFontFamily
    );

    document.documentElement.style.setProperty(
      "--font-family",
      savedFontFamily
    );
  }, []);

  return (
    <div className="flex items-center gap-2">
      <span className="font-semibold">
        Font Style:
      </span>

      <Dropdown
        value={selectedFontFamily}
        options={fontFamilies}
        optionLabel="label"
        optionValue="value"
        placeholder="Font Style"
        className="w-12rem"
        onChange={changeFontFamily}
      />
    </div>
  );
}